import { List } from 'immutable';
import Base from 'records/Base';
import CustomSize, {
    mapToRecords
} from 'records/CustomSize';
import {
    SET_CUSTOM_SIZE_RECORDS,
    UPDATE_ALL_CUSTOM_SIZE_RECORDS,
    UPDATE_CUSTOM_SIZE_RECORD,
    CUSTOM_SIZE_ACTION_START,
    RESET_CUSTOM_SIZE_RECORDS,
    CUSTOM_SIZE_ACTION_FAILURE,
    CUSTOM_SIZE_ACTION_FINISH,
} from 'actions/customSize';

const initialState = new Base({
    loading: false,
    errorMessage: null,
    data: new List(),
});

const actionsMap = {

    [SET_CUSTOM_SIZE_RECORDS]: (state, action) => state.merge({
        loading: false,
        errorMessage: null,
        data: mapToRecords(action.data),
    }),

    [UPDATE_ALL_CUSTOM_SIZE_RECORDS]: (state, action) => {
        const {
            width,
            height,
            isBleedEnabled,
        } = action.data;

        const updatedRecords = state.get('data').map(record => record.merge({
            width,
            height,
            isBleedEnabled,
        }));

        return state.merge({
            loading: false,
            errorMessage: null,
            data: updatedRecords,
        });
    },

    [UPDATE_CUSTOM_SIZE_RECORD]: (state, action) => {
        const {
            width,
            height,
            isBleedEnabled,
            pageOrdinal,
        } = action.data;

        const updatedRecords = state.get('data').map(record =>
            pageOrdinal == record.get('pageOrdinal') ?
                record.merge({
                    width,
                    height,
                    isBleedEnabled,
                }) :
                new CustomSize(record)
        );

        return state.merge({
            loading: false,
            errorMessage: null,
            data: updatedRecords,
        });
    },

    [RESET_CUSTOM_SIZE_RECORDS]: () => initialState,

    [CUSTOM_SIZE_ACTION_START]: state => state.merge({
        loading: true,
    }),

    [CUSTOM_SIZE_ACTION_FINISH]: state => state.merge({
        loading: false,
        errorMessage: null,
    }),

    [CUSTOM_SIZE_ACTION_FAILURE]: (state, action) => {
        const { message } = action.data;
        return state.merge({
            loading: false,
            errorMessage: message,
        });
    },

};

export default function customSize(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}
